import { render, staticRenderFns } from "./centralInfo.vue?vue&type=template&id=2cdd4606&"
import script from "./centralInfo.vue?vue&type=script&lang=js&"
export * from "./centralInfo.vue?vue&type=script&lang=js&"
import style0 from "./centralInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports